/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMinusVertical = createReactComponent("outline", "minus-vertical", "IconMinusVertical", [["path", { "d": "M12 5v14", "key": "svg-0" }]]);

export { IconMinusVertical as default };
//# sourceMappingURL=IconMinusVertical.mjs.map
